// extracted by mini-css-extract-plugin
module.exports = {"pipsContainer":"Pips_pipsContainer__Izh0O","pip":"Pips_pip__Bq6s5","selectedPip":"Pips_selectedPip__Zyvxp","video":"Pips_video__0kIro"};